import React from 'react';
import SvgIcon from './SvgIcon';
import styles from './LoadingSpinner.module.css';
/**
 * @param {FF.SvgIcon} props
 */
export default function LoadingSpinner(props) {
  return (
    <SvgIcon
      viewBox="0 0 66 66"
      {...props}
      className={`${styles.spinner} ${props.className || ''}`}
    >
      <circle cx="33" cy="33" r="30" />
    </SvgIcon>
  );
}
